var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c(
        "CabeceraModal",
        {
          attrs: { titulo: "Editar Equipo" },
          on: { cerrar: _vm.handleCerrar }
        },
        [
          _c("div", {
            staticStyle: {
              "letter-spacing": "0.02em",
              "white-space": "nowrap",
              overflow: "hidden",
              "text-overflow": "ellipsis",
              "margin-top": "16px"
            }
          }),
          _c(
            "div",
            { staticClass: "boton_crear" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "icon",
                  staticStyle: {
                    "background-color": "rgb(255, 108, 0)",
                    "border-color": "rgb(255, 108, 0)",
                    "padding-right": "20px",
                    display: "block",
                    margin: "0 0 0 auto",
                    "margin-top": "13px",
                    height: "38px"
                  },
                  on: { click: _vm.editar }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "color-blanco",
                      staticStyle: { color: "white" }
                    },
                    [_vm._v("Guardar")]
                  )
                ]
              )
            ],
            1
          )
        ]
      ),
      _c("CrudStepsNavBar", {
        attrs: { pasos: _vm.pasos, "validar-paso": false },
        model: {
          value: _vm.pasoActivoIndex,
          callback: function($$v) {
            _vm.pasoActivoIndex = $$v
          },
          expression: "pasoActivoIndex"
        }
      }),
      _c("ContenidoModal", [
        _c(
          "div",
          { attrs: { align: "center" } },
          [
            _c(
              "v-flex",
              { attrs: { md10: "" } },
              [
                _c(
                  "v-card",
                  { staticClass: "rounded-card" },
                  [
                    _c(
                      "v-form",
                      {
                        ref: "form",
                        staticClass: "col-md-12",
                        attrs: { "lazy-validation": "" }
                      },
                      [
                        _c(
                          "v-container",
                          {
                            staticStyle: { padding: "30px 40px 50px 40px" },
                            attrs: { "grid-list-md": "" }
                          },
                          [
                            _c(
                              "FormFieldsContainer",
                              { attrs: { "mb-3": "" } },
                              [
                                _c("h2", { staticClass: "ml-2" }, [
                                  _vm._v("Editar Equipos")
                                ]),
                                _c("v-flex", { attrs: { sm10: "", md10: "" } }),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: { label: "Cuenta INET" },
                                      model: {
                                        value:
                                          _vm.formFields.tipoeqcuenta_inet
                                            .value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.tipoeqcuenta_inet,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formFields.tipoeqcuenta_inet.value"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs4: "", sm4: "", md4: "" } },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        label: _vm.formFields.plataform.label,
                                        items: _vm.plataformas,
                                        "item-text": "configvalor",
                                        "item-value": "configid",
                                        clearable: "",
                                        disabled: true
                                      },
                                      model: {
                                        value: _vm.formFields.plataform.value,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.formFields.plataform,
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression: "formFields.plataform.value"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }